import styled from "@emotion/styled"

const ListTwoCardSeparator = styled.hr`
  width: 40px;
  display: block;
  height: 1px;
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  margin-bottom: 4px;

  ${({ theme }) => theme.breakpoints.down("lg")} {
    margin: 0px 0px 4px 0px;
  }
`

export default ListTwoCardSeparator
